module.exports = __webpack_public_path__ + "img/b5.32ff850d.png";